import React from "react";
import { Show, SimpleShowLayout,TextField,ArrayField,SingleFieldList,ChipField,ReferenceManyField,Datagrid,EmailField } from "react-admin";

export const RoleShow=(props)=>{
    return (
        <Show {...props}>
            <SimpleShowLayout>
  <TextField source="name" label="Nombre del Rol" />
  <TextField source="description" label="Descripcion" />
  <TextField source="status" label="Estado" />
  <TextField source="createdAt" label="Creado" />
  <TextField source="updatedAt" label="Actualizado" />

  <ArrayField source="permissions" label="Permisos">
    <SingleFieldList>
      <ChipField source="name" />
    </SingleFieldList>
  </ArrayField>
  <ReferenceManyField
  label="Usuarios con este Rol"
  reference="users"
  target="roleId"
>
  <Datagrid>
    <TextField source="firstName" label="Nombre" />
    <EmailField source="email" label="Correo" />
    <TextField source="createdAt" label="Fecha de Creación" />
  </Datagrid>
</ReferenceManyField>

</SimpleShowLayout>


        </Show>
    )
}